import { render, staticRenderFns } from "./PDPRiverContent.vue?vue&type=template&id=558fa1d7&scoped=true"
import script from "./PDPRiverContent.vue?vue&type=script&lang=js"
export * from "./PDPRiverContent.vue?vue&type=script&lang=js"
import style0 from "./PDPRiverContent.vue?vue&type=style&index=0&id=558fa1d7&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558fa1d7",
  null
  
)

export default component.exports